import React, { useEffect } from "react";
import Swal from "sweetalert2";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { getUserById } from "../../redux/reducers/userSlice";
import { syncUserStatus } from "../../redux/reducers/syncSlice";
import { baseUrl } from "../../redux";

const Success = () => {
  const navigate = useNavigate(); // Get the navigate function
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const { userData } = useSelector((state) => state.auth ?? {});
  const { userId } = userData;

  // useEffect(() => {
  //   const sessionId = searchParams.get("session_id");
  //   if (sessionId) {
  //     handlePaymentSuccess(sessionId);

  //   }
  // }, [searchParams]);
  const handlePaymentSuccess = async (sessionId) => {
    try {
      const response = await axios.post(
        `${baseUrl}/success?session_id=${sessionId}`
      );
      return response.data;
    } catch (error) {}
  };

  // useEffect(() => {
  //   // Show the SweetAlert2 alert
  //   Swal.fire({
  //     title: "Payment Successful!",
  //     text: "You will be redirected shortly.",
  //     icon: "success",
  //     timer: 3000, // Time in milliseconds (3000ms = 3 seconds)
  //     timerProgressBar: true,
  //     buttons: false,
  //     willClose: () => {
  //       // This function will be called when the alert is closed
  //       navigate("/checkout"); // Replace '/new-route' with your desired route

  //     },
  //   });

  // }, [navigate]);
  useEffect(() => {
    const sessionId = searchParams.get("session_id");
    if (sessionId) {
      handlePaymentSuccess(sessionId).then(() => {
        dispatch(syncUserStatus()); // Sync after payment
        Swal.fire({
          title: "Payment Successful!",
          text: "You will be redirected shortly.",
          icon: "success",
          timer: 2000,
          timerProgressBar: true,
          showConfirmButton: false,
          willClose: () => {
            navigate("/checkout");
          },
        });
      });
    }
  }, [searchParams]);

  return null;
};

export default Success;
